export enum ItemState {

  Enabled = 1,
  Disabled = 2

}
